/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Error_Verification_FailedInputs */

const en_login_error_verification_failed = /** @type {(inputs: Login_Error_Verification_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to send verification email. Please try again.`)
};

const fr_login_error_verification_failed = /** @type {(inputs: Login_Error_Verification_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de l'envoi de l'email de vérification. Veuillez réessayer.`)
};

const de_login_error_verification_failed = /** @type {(inputs: Login_Error_Verification_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Bestätigungs-E-Mail konnte nicht gesendet werden. Bitte versuchen Sie es erneut.`)
};

const it_login_error_verification_failed = /** @type {(inputs: Login_Error_Verification_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile inviare l'email di verifica. Riprova.`)
};

const ru_login_error_verification_failed = /** @type {(inputs: Login_Error_Verification_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось отправить письмо с подтверждением. Пожалуйста, попробуйте еще раз.`)
};

const es_login_error_verification_failed = /** @type {(inputs: Login_Error_Verification_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo enviar el correo electrónico de verificación. Inténtalo de nuevo.`)
};

const zh_cn2_login_error_verification_failed = /** @type {(inputs: Login_Error_Verification_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`验证邮件发送失败，请重试。`)
};

const ja_login_error_verification_failed = /** @type {(inputs: Login_Error_Verification_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`確認メールを送信できませんでした。もう一度お試しください。`)
};

const hi_login_error_verification_failed = /** @type {(inputs: Login_Error_Verification_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सत्यापन ईमेल भेजने में विफलता। कृपया पुनः प्रयास करें।`)
};

const pt_pt2_login_error_verification_failed = /** @type {(inputs: Login_Error_Verification_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha ao enviar o e-mail de verificação. Tente novamente.`)
};

/**
* | output |
* | --- |
* | "Failed to send verification email. Please try again." |
*
* @param {Login_Error_Verification_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_error_verification_failed = /** @type {((inputs?: Login_Error_Verification_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Error_Verification_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_error_verification_failed(inputs)
	if (locale === "de") return de_login_error_verification_failed(inputs)
	if (locale === "it") return it_login_error_verification_failed(inputs)
	if (locale === "ru") return ru_login_error_verification_failed(inputs)
	if (locale === "es") return es_login_error_verification_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_login_error_verification_failed(inputs)
	if (locale === "ja") return ja_login_error_verification_failed(inputs)
	if (locale === "hi") return hi_login_error_verification_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_login_error_verification_failed(inputs)
	return en_login_error_verification_failed(inputs)
});